import Page from '@/components/Page/Page';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import { PageModel } from '@/models/page';
import Button from '@uikit/components/Button/Button';
import { ButtonSize } from '@uikit/components/Button/consts';
import ButtonLink from '@uikit/components/ButtonLink/ButtonLink';
import { ClickableAction } from '@uikit/components/Clickable/consts';
import CourseDetailPageContent from '@uikit/components/CourseDetailPageContent/CourseDetailPageContent';
import EnercityGwkFooter from '@uikit/components/EnercityGwkFooter/EnercityGwkFooter';
import Layout from '@uikit/components/Layout/Layout';
import NewHeader from '@uikit/components/NewHeader/NewHeader';
import PageHeader from '@uikit/components/NewHeader/PageHeader/PageHeader';
import type { CourseDetailPageProps } from './types';

const CourseDetailPage = (pageData: PageModel<CourseDetailPageProps>) => {
  const meta = extractPageMetaFromRouteData(pageData);

  const {
    props: { events = [], ...props },
  } = pageData;

  useInitialPageDataLayer();

  const transformedEvents = events.map(({ startDate, endDate, ...rest }) => ({
    startDate: new Date(startDate),
    endDate: new Date(endDate),
    ...rest,
  }));

  return (
    <Layout>
      <Page meta={meta}>
        <NewHeader
          hasPageHeader
          hasPreHeader={true}
          renderPageHeader={(props) => (
            <PageHeader
              {...props}
              renderTitle={() => (
                <ButtonLink
                  actionType={ClickableAction.Linkintern}
                  linkintern={pageData.props.category.path}
                  icon="action/arrow-left"
                  disableTransition
                >
                  {pageData.props.category.title}
                </ButtonLink>
              )}
              addonsSlot={
                <Button
                  actionType={ClickableAction.Anchor}
                  anchor="events-section"
                  size={ButtonSize.Small}
                >
                  Jetzt Anmelden
                </Button>
              }
            />
          )}
          variant="enercity-gwk"
        />

        <CourseDetailPageContent events={transformedEvents} {...props} />
      </Page>

      <EnercityGwkFooter />
    </Layout>
  );
};
export default CourseDetailPage;
